module.exports = __webpack_public_path__ + "static/TownOfLight2-469efbe857db69b77f13fc530cdfefa8.png";